module.exports = __webpack_public_path__ + "static/media/id.17b99676.svg";